<template>
  <div class="container-protecao">
    <div class="painel"></div>    
   <router-view />
  </div>
</template>

<script>
export default {  
  mounted(){
     document.documentElement.scrollTop = 0;
  }
}
</script>

<style>
.painel{
  background-image: url('/sandboxfront/img/header.png') ;  
  background-repeat: no-repeat;
  position: relative;
 background-size: 100%;
  width: 100%;
  max-height: 415px;
  display: flex;
  align-items: center;
  padding-bottom:10%;
  justify-content: center;
}
.container-protecao{
  width: 100%;
  max-width: 1200px;
  margin:0 auto;
  background:#fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}







</style>